module.exports = __webpack_public_path__ + "static/bigdog-black-55e4a3f5e814dc10129ba6741ea3dfd2.png";